/**
 * Partial save for the additional-information form.
 *
 * Reuses the existing simple-lead-processor edge function. The edge function
 * is extended (separate edit) to recognize the `additional_information` key
 * in the request body and persist it into the new JSONB column on simple_leads.
 *
 * Fired on field blur once the user has touched at least one field.
 */

import type { AdditionalInfoFormConfig } from './types';

export async function sendPartialSave(
  config: AdditionalInfoFormConfig,
  additionalInformation: Record<string, string>
): Promise<void> {
  if (!config.sessionId) {
    if (config.debug) {
      console.warn('[additional-info] partial save skipped — no session id');
    }
    return;
  }

  const payload = {
    session_id: config.sessionId,
    form_data: {},
    additional_information: additionalInformation,
    is_complete: false,
    tracking_data: config.trackingData ?? {},
  };

  try {
    const response = await fetch(config.partialSaveUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: config.supabaseAnonKey,
        Authorization: `Bearer ${config.supabaseAnonKey}`,
      },
      credentials: 'omit',
      body: JSON.stringify(payload),
    });

    if (!response.ok && config.debug) {
      console.warn(
        `[additional-info] partial save failed: ${response.status} ${response.statusText}`
      );
    } else if (config.debug) {
      console.log('[additional-info] partial save ok');
    }
  } catch (err) {
    if (config.debug) {
      console.warn('[additional-info] partial save error:', err);
    }
  }
}
